(() => {
  const root = document.querySelector('[data-veloris-landing], [data-veloris-legal-page]');

  if (!root) return;

  const menuToggle = root.querySelector('[data-nav-menu-toggle]');
  const navLinks = root.querySelector('.veloris-nav__links');

  if (menuToggle && navLinks) {
    menuToggle.addEventListener('click', () => {
      const isOpen = navLinks.classList.toggle('is-open');
      menuToggle.setAttribute('aria-expanded', String(isOpen));
    });

    navLinks.querySelectorAll('a').forEach((link) => {
      link.addEventListener('click', () => {
        navLinks.classList.remove('is-open');
        menuToggle.setAttribute('aria-expanded', 'false');
      });
    });
  }

  root.querySelectorAll('.veloris-faq details').forEach((item) => {
    item.addEventListener('toggle', () => {
      if (!item.open) return;

      root.querySelectorAll('.veloris-faq details[open]').forEach((openItem) => {
        if (openItem !== item) openItem.removeAttribute('open');
      });
    });
  });

  const setupCarousel = (track, itemSelector, prevSelector, nextSelector, gap, startAt) => {
    const prevBtn = root.querySelector(prevSelector);
    const nextBtn = root.querySelector(nextSelector);

    if (!track || !prevBtn || !nextBtn) return;

    const updateArrows = () => {
      const maxScroll = track.scrollWidth - track.clientWidth;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= maxScroll - 1;
    };

    const scrollByItem = (direction) => {
      const item = track.querySelector(itemSelector);
      const amount = item ? item.getBoundingClientRect().width + gap : track.clientWidth;
      track.scrollBy({ left: amount * direction, behavior: 'smooth' });
    };

    prevBtn.addEventListener('click', () => scrollByItem(-1));
    nextBtn.addEventListener('click', () => scrollByItem(1));
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);

    const isMobile = window.matchMedia('(max-width: 749px)').matches;

    if (startAt === 'end' && !isMobile) {
      track.scrollLeft = track.scrollWidth - track.clientWidth;
    }

    updateArrows();
  };

  setupCarousel(root.querySelector('.veloris-reviews'), 'article', '[data-reviews-prev]', '[data-reviews-next]', 16, 'start');
  setupCarousel(root.querySelector('.veloris-voice-grid'), '.veloris-voice-grid__item', '[data-voices-prev]', '[data-voices-next]', 16, 'start');

  const voiceItems = root.querySelectorAll('.veloris-voice-grid__item');

  const pauseOtherVoices = (current) => {
    voiceItems.forEach((other) => {
      if (other === current) return;
      other.classList.remove('is-playing', 'is-paused');
      const otherVideo = other.querySelector('video');
      if (otherVideo) otherVideo.pause();
    });
  };

  voiceItems.forEach((item) => {
    const video = item.querySelector('video');
    const progressBar = item.querySelector('.veloris-voice-grid__progress-bar');

    if (video) {
      video.addEventListener('play', () => {
        pauseOtherVoices(item);
        item.classList.remove('is-paused');
        item.classList.add('is-playing');
      });

      video.addEventListener('pause', () => {
        item.classList.remove('is-playing');
        item.classList.add('is-paused');
      });

      video.addEventListener('ended', () => {
        item.classList.remove('is-playing', 'is-paused');
      });

      video.addEventListener('timeupdate', () => {
        if (progressBar && video.duration) {
          progressBar.style.width = `${(video.currentTime / video.duration) * 100}%`;
        }
      });

      item.addEventListener('click', () => {
        if (video.paused) {
          video.muted = false;
          video.volume = 1;
          video.play().catch(() => {});
        } else {
          video.pause();
        }
      });
    } else {
      item.addEventListener('click', () => {
        const isPlaying = item.classList.contains('is-playing');

        pauseOtherVoices(item);

        if (!isPlaying) item.classList.add('is-playing');
      });
    }
  });

  const buyModal = root.querySelector('[data-buy-modal]');

  if (buyModal) {
    const variantsScript = buyModal.querySelector('[data-product-json]');
    const variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    const optionGroups = buyModal.querySelectorAll('.veloris-buy-modal__option:not(.veloris-buy-modal__option--quantity)');
    const priceEl = buyModal.querySelector('[data-modal-price]');
    const checkoutBtn = buyModal.querySelector('[data-modal-checkout]');
    const errorEl = buyModal.querySelector('[data-modal-error]');
    const qtyValueEl = buyModal.querySelector('[data-qty-value]');
    const qtyDecreaseBtn = buyModal.querySelector('[data-qty-decrease]');
    const qtyIncreaseBtn = buyModal.querySelector('[data-qty-increase]');
    const selected = [];
    let quantity = 1;

    const formatMoney = (cents) => `$ ${(cents / 100).toFixed(2)}`;

    const findVariant = () =>
      variants.find((variant) => variant.options.every((value, index) => selected[index] === undefined || value === selected[index]));

    const updateState = () => {
      const variant = findVariant();

      if (variant) {
        priceEl.textContent = formatMoney(variant.price);
        checkoutBtn.disabled = !variant.available;
        errorEl.hidden = variant.available;
        checkoutBtn.dataset.variantId = variant.id;
      } else {
        checkoutBtn.disabled = true;
        checkoutBtn.removeAttribute('data-variant-id');
        errorEl.hidden = false;
        errorEl.textContent = 'This combination is currently unavailable.';
      }
    };

    optionGroups.forEach((group, index) => {
      const pills = group.querySelectorAll('.veloris-buy-modal__pill');

      pills.forEach((pill, pillIndex) => {
        if (pillIndex === 0) {
          selected[index] = pill.dataset.optionValue;
          pill.classList.add('is-selected');
        }

        pill.addEventListener('click', () => {
          pills.forEach((other) => other.classList.remove('is-selected'));
          pill.classList.add('is-selected');
          selected[index] = pill.dataset.optionValue;
          updateState();
        });
      });
    });

    updateState();

    const galleryImage = buyModal.querySelector('[data-modal-gallery-image]');
    const galleryDots = buyModal.querySelectorAll('.veloris-buy-modal__gallery-dot');
    const galleryFrame = buyModal.querySelector('.veloris-buy-modal__image-frame');
    let activeGalleryIndex = Math.max(
      0,
      Array.from(galleryDots).findIndex((dot) => dot.classList.contains('is-active'))
    );
    let galleryTouchStartX = 0;
    let galleryTouchStartY = 0;

    const showGalleryImage = (index) => {
      if (!galleryImage || !galleryDots.length) return;

      activeGalleryIndex = (index + galleryDots.length) % galleryDots.length;
      galleryDots.forEach((dot, dotIndex) => {
        const isActive = dotIndex === activeGalleryIndex;
        dot.classList.toggle('is-active', isActive);
        dot.setAttribute('aria-current', isActive ? 'true' : 'false');
      });
      galleryImage.src = galleryDots[activeGalleryIndex].dataset.gallerySrc;
    };

    galleryDots.forEach((dot, index) => {
      dot.addEventListener('click', () => {
        showGalleryImage(index);
      });
    });

    if (galleryFrame && galleryDots.length > 1) {
      galleryFrame.addEventListener(
        'touchstart',
        (event) => {
          const touch = event.changedTouches[0];
          galleryTouchStartX = touch.clientX;
          galleryTouchStartY = touch.clientY;
        },
        { passive: true }
      );

      galleryFrame.addEventListener(
        'touchend',
        (event) => {
          const touch = event.changedTouches[0];
          const deltaX = touch.clientX - galleryTouchStartX;
          const deltaY = touch.clientY - galleryTouchStartY;

          if (Math.abs(deltaX) < 40 || Math.abs(deltaX) <= Math.abs(deltaY)) return;
          showGalleryImage(activeGalleryIndex + (deltaX < 0 ? 1 : -1));
        },
        { passive: true }
      );
    }

    showGalleryImage(activeGalleryIndex);

    if (qtyValueEl && qtyDecreaseBtn && qtyIncreaseBtn) {
      const renderQuantity = () => {
        qtyValueEl.textContent = String(quantity);
        qtyDecreaseBtn.disabled = quantity <= 1;
      };

      qtyDecreaseBtn.addEventListener('click', () => {
        quantity = Math.max(1, quantity - 1);
        renderQuantity();
      });

      qtyIncreaseBtn.addEventListener('click', () => {
        quantity += 1;
        renderQuantity();
      });

      renderQuantity();
    }

    const openModal = () => {
      buyModal.hidden = false;
      document.body.classList.add('veloris-modal-open');
    };

    const closeModal = () => {
      buyModal.hidden = true;
      document.body.classList.remove('veloris-modal-open');
    };

    buyModal.querySelectorAll('[data-buy-modal-close]').forEach((el) => {
      el.addEventListener('click', closeModal);
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && !buyModal.hidden) closeModal();
    });

    root.querySelectorAll('.veloris-offer__form, .veloris-final__form').forEach((form) => {
      form.addEventListener('submit', (event) => {
        event.preventDefault();
        openModal();
      });
    });

    const cartBtn = root.querySelector('.veloris-nav__cart-btn');

    if (cartBtn) {
      cartBtn.addEventListener('click', (event) => {
        event.preventDefault();
        openModal();
      });
    }

    checkoutBtn.addEventListener('click', () => {
      const variant = findVariant();

      if (!variant || !variant.available) return;

      checkoutBtn.disabled = true;

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: [{ id: variant.id, quantity }] }),
      })
        .then((response) => {
          if (!response.ok) throw new Error('Add to cart failed');
          window.location.href = '/checkout';
        })
        .catch(() => {
          checkoutBtn.disabled = false;
          errorEl.hidden = false;
          errorEl.textContent = 'Something went wrong. Please try again.';
        });
    });
  }
})();
